<div class="row align-items-center justify-content-between mb-3">
  <div class="col-12 col-lg-auto mb-3 mb-lg-0">
    <app-searchbox [(ngModel)]="searchTerm" (ngModelChange)="getSummariesRequest$.next()" [label]="searchLabel | translate">
    </app-searchbox>
  </div>
  <div class="col-12 col-lg-auto">
    <app-responsive-pagination
      [(page)]="page"
      [(pageSize)]="pageSize"
      [collectionSize]="totalSummaries$ | async"
      [entryLimits]="DEFAULT_ENTRY_LIMITS"
    ></app-responsive-pagination>
  </div>
</div>

<div>
  <app-ngb-table [config]="tableConfig" [data]="tableData$ | async"></app-ngb-table>
</div>

<div class="pagination-entries justify-content-end">
  <app-responsive-pagination
    [(page)]="page"
    [(pageSize)]="pageSize"
    [collectionSize]="totalSummaries$ | async"
    [entryLimits]="DEFAULT_ENTRY_LIMITS"
  ></app-responsive-pagination>
</div>
